export default __webpack_public_path__ + "static/media/my_community_hero.5824e2f8.webp";